import React, { ChangeEvent, FC } from 'react';

import CustomTooltip from 'shared/components/Tooltip';

import styles from './index.module.scss';

interface CheckboxProps {
	disabled?: boolean;
	required?: boolean;
	tooltip?: string;
	// eslint-disable-next-line no-unused-vars
	changeHandle?: (checked: boolean, value?: number | undefined) => void;
	label?: string | JSX.Element;
	value?: number;
	defaultChecked?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({
	disabled,
	required,
	tooltip,
	changeHandle,
	label,
	value,
	defaultChecked,
}: CheckboxProps) => {
	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (changeHandle) changeHandle(e.target.checked, value);
	};

	return tooltip ? (
		<CustomTooltip
			title={<span style={{ display: 'flex', textAlignLast: 'center' }}>{tooltip}</span>}
			arrow={true}
			placement="top"
		>
			<label className={styles.container} title={disabled ? 'not allowed' : ''}>
				<input
					type="checkbox"
					onChange={handleChange}
					required={required}
					value={value}
					disabled={disabled}
					checked={defaultChecked}
				/>
				<span className={styles.checkmark} />
				{label}
			</label>
		</CustomTooltip>
	) : (
		<label className={styles.container} title={disabled ? 'not allowed' : ''}>
			<input
				type="checkbox"
				onChange={handleChange}
				required={required}
				value={value}
				disabled={disabled}
				checked={defaultChecked}
			/>
			<span className={styles.checkmark} />
			{label}
		</label>
	);
};

export default Checkbox;
